import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { OnboardingStatus } from '../data/onboarding-status';
import { OrganizationDetail } from '../data/organization-detail';
import { EmailSupportModalComponent } from '../email-support-modal/email-support-modal.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-org-onboarding',
  templateUrl: './org-onboarding.component.html',
  styleUrls: ['./org-onboarding.component.scss']
})
export class OrgOnboardingComponent extends BaseComponent implements OnInit {

  @ViewChild("emailModal", { static: false }) emailModal: EmailSupportModalComponent;

  organizationId: number;
  organizationDetails: OrganizationDetail;
  status: OnboardingStatus;
  statusLoading: boolean = true;
  environment = environment;

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.organizationId) {
        this.organizationId = params.organizationId;
      }
      else {
        this.organizationId = this.organizationService.getRootOrgs()[0].ID;
      }
      this.dataService.getOrganizationDetail(this.organizationId).subscribe(o => {
        this.organizationDetails = o;
      })
      this.dataService.getOnboardingStatus(this.organizationId).subscribe(s => {
        this.status = s;
        this.statusLoading = false;
      });
    })
  }

  openSupportModal() {
    this.emailModal.openForNew();
    return false;
  }
}
